import type { PlayerDetail } from '~/domains/games/interfaces/player-detail.interface';

import type { PlayerGroupedStats } from '../../components/GamecenterPlayerDetail/GamecenterPlayerDetailStats';

const parseBaseball = (playerData: PlayerDetail): PlayerGroupedStats => ({
  name: 'Season averages',
  orderedStats: [
    {
      name: '.BA',
      value: playerData.attributes?.statistics?.hitting?.batting_average ?? '-',
    },
    {
      name: 'AB',
      value: playerData.attributes?.statistics?.hitting?.at_bats_per_game ?? '-',
    },
    {
      name: 'HITS',
      value: playerData.attributes?.statistics?.hitting?.hits_per_game ?? '-',
    },
    {
      name: 'RUNS',
      value: playerData.attributes?.statistics?.hitting?.runs_per_game ?? '-',
    },
    {
      name: 'RBI',
      value: playerData.attributes?.statistics?.hitting?.rbi_per_game ?? '-',
    },
    {
      name: 'TB',
      value: playerData.attributes?.statistics?.hitting?.total_bases_per_game ?? '-',
    },
    {
      name: 'HR',
      value: playerData.attributes?.statistics?.hitting?.home_runs_per_game ?? '-',
    },
    {
      name: 'SO',
      value: playerData.attributes?.statistics?.hitting?.total_strikeouts_per_game ?? '-',
    },
    {
      name: 'SB',
      value: playerData.attributes?.statistics?.hitting?.stolen_bases_per_game ?? '-',
    },
  ],
});

export default parseBaseball;
